import React from 'react'

import ColumnsList from './columns/ColumnsList'
import ScreenLoader from './_load/ScreenLoader'

const Kanban = ({ screenId, ...props }) => {
  return (
    <ScreenLoader id={screenId}>
      <ColumnsList {...props} />
    </ScreenLoader>
  )
}

export default Kanban
